/**
 * GENERATED by scripts/brand/logo.py — run `make logo` to rewrite it.
 *
 * The Bitwize mark as data: which cells of the lattice are inside the B, and
 * the bitstream that fills them. `BrandMark.tsx` draws it; the standalone files
 * in public/brand are the same lattice rendered ahead of time for the places
 * that need a URL rather than a component.
 *
 * Fixed rather than generated at render time, for the reason `bitRows.ts`
 * gives: a pattern that differs between the server and the client fails
 * hydration. Here there is a second reason — a logo that differs between two
 * builds is not a logo.
 */

/** One row per lattice row; `#` is inside the letterform, `.` is outside. */
export const MARK_ROWS = [
  '##########...',
  '###########..',
  '###.....###..',
  '###......###.',
  '###......###.',
  '###.....###..',
  '###########..',
  '############.',
  '###......###.',
  '###.......###',
  '###.......###',
  '###.......###',
  '###......###.',
  '############.',
  '##########...',
] as const;

/** ASCII bits of 'bitwize software company', laid across the lit cells in reading order. */
export const MARK_BITS =
  '01100010011010010111010001110111011010010111101001100101001000000111001101101111011001100111010001110111011000010111001001100101001000000110001101101111011011010111000001100001011011100111100100100000';

/** Lattice cell size, in the mark's own user units. */
export const MARK_CELL = 24;

/** Gap between cells, in the same units — what makes the lattice read as one. */
export const MARK_GAP = 3;
